import { DEFAULT_PAGE_SIZE } from '../utils/constants';

const APIConfig = {
  baseURL: process.env.REACT_APP_API_URL || '',
  relPath: '/api/admin',
  login: '/signin',
  verification: '/verification',
  refreshToken: '/oauth2/token',
  logOut: '/logout',
  organization: '/organizations',
  features: '/permissions',
  licence: '/licence',
  forget: '/forget',
  passVerification: '/pass-verification',
  setPassword: '/set',
  addWhiteListItem: '/whitelist/{subdomain}/phone/add/',
  removeWhiteListItem: '/whitelist/{subdomain}/phone/remove/',
  fetchWhiteList: `/whitelist/{subdomain}/phone/list?page={page}&size=${DEFAULT_PAGE_SIZE}`,
  allOrgCSVData: '/organizations/csv'
}

export default APIConfig
